"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStepType = void 0;
exports.WorkflowStepType = {
    ContentPack: 'content_pack',
    Poll: 'poll',
    Confirm: 'confirm',
    QuestionWithAnswers: 'question_with_answers',
    UserConsents: 'user_consents',
    CheckInEntry: 'check_in_entry',
    AccessCodeInput: 'access_code_input',
    CheckSponsorshipEligibility: 'check_sponsorship_eligibility',
    CountryResidence: 'country_residence',
    Conditions: 'conditions',
    SsoAccountValidation: 'sso_account_validation',
    StepEndWorkflow: 'step-end-workflow',
    SurveyStatement: 'survey_statement',
    SurveyPrompt: 'survey_prompt',
    Guide: 'guide',
};
//# sourceMappingURL=workflow-step-type.js.map